import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import AcademicCalenderEle from './AcademicCalenderEle'


function Main() {
    return (
      <>
          <Header/>
          <Breadcrumb title="Home" subtitle="Academic Calendars"/>
          <AcademicCalenderEle />
      </>
    )
  }
  
  export default Main